import React, { useState } from "react";
import "./styles.scss";
import { Modal, Backdrop, CircularProgress, InputLabel } from "@mui/material";
import { Clear } from "@mui/icons-material";

import { useStateValue } from "../../store";
import Button from "../../common/button";
import Input from "../../common/Input";
import { getIsipCodeValid, getCartList } from "../../store/homeAction/action";

const ZipCodePopup = () => {
  const [{ zipCodePopup }, dispatch] = useStateValue();
  const [loading, setLoading] = useState(false);
  const [apiMessage, setApiResponse] = useState({
    success: "",
    error: "",
  });

  const [inputValidation, setInputValidation] = useState("");

  const [open, setOpen] = React.useState(true);

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    else {
      let temp = sessionStorage.getItem("iszipAuth");
      if (temp === "" || null) {
        dispatch({
          type: "SET_ZIP_CODE_POPUP",
          value: false,
          data: {
            installation: false,
            fall_prevention: false,
          },
        });
      } else {
        dispatch({
          type: "SET_ZIP_CODE_POPUP",
          value: false,
          data: {
            ...zipCodePopup?.zipCodeData,
          },
        });
      }
      setOpen(false);
    }
  };
  // get if zip code valid for the location
  const handleZipCodeValid = () => {
    if (!zipCodePopup?.zipCodeData?.zipCode) {
      document.getElementById("postal-code")?.focus();
      setInputValidation("Please enter the postal code.");
    } else if (
      zipCodePopup?.zipCodeData?.zipCode.replaceAll(" ", "")?.length < 6
    ) {
      document.getElementById("postal-code")?.focus();
      setInputValidation("Please enter minimum 6 digit postal code.");
    } else {
      setLoading(true);
      let installation = "";
      let fall_prevention = "";
      if (
        !zipCodePopup?.zipCodeData?.installation &&
        !zipCodePopup?.zipCodeData?.fall_prevention
      ) {
        installation = true;
        fall_prevention = true;
      } else {
        installation = zipCodePopup?.zipCodeData?.installation;
        fall_prevention = zipCodePopup?.zipCodeData?.fall_prevention;
      }
      let payload = {
        installation: installation,
        fall_prevention: fall_prevention,
        session_key: sessionStorage.getItem("session_key"),
        zip: zipCodePopup?.zipCodeData?.zipCode,
      };

      getIsipCodeValid((res, error) => {
        dispatch({
          type: "SET_ZIP_CODE_POPUP",
          data: res?.data ? res?.data : error?.data,
          // value: true,
        });
        sessionStorage.setItem("iszipAuth", res?.status ? res?.data?.zip : "");
        if (res?.data?.session_key) {
          sessionStorage.setItem("session_key", res?.data?.session_key);
        }
        dispatch({
          type: "SET_ALERT_MESSAGE",
          value: true,
          data: {
            severity: error?.data?.message ? "error" : "success",
            message: error?.data?.message ? error?.data?.message : res?.message,
          },
        });
        setLoading(false);
        setApiResponse({
          success: res?.message,
          error: error?.data?.message,
        });
        dispatch({
          type: "SET_IS_LOADING",
          value: true,
        });
        let payload = {
          session_key: sessionStorage.getItem("session_key"),
        };
        getCartList((res, error) => {
          dispatch({
            type: "SET_CARTLIST_DATA",
            data: res,
          });
          sessionStorage.setItem(
            "iszipAuth",
            res?.data?.installation_content?.postal_code
          );
          dispatch({
            type: "SET_ZIP_CODE_POPUP",
            value: false,
            data: {
              installation: res?.data?.installation_content?.installation,
              fall_prevention: res?.data?.installation_content?.fall_prevention,
              zipCode: res?.data?.installation_content?.postal_code,
            },
          });
          dispatch({
            type: "SET_IS_LOADING",
            value: false,
          });
        }, payload);
      }, payload);
    }
  };

  const handleChange = (event) => {
    setInputValidation("");
    dispatch({
      type: "SET_ZIP_CODE_POPUP",
      value: true,
      data: {
        installation: zipCodePopup?.zipCodeData?.installation,
        fall_prevention: zipCodePopup?.zipCodeData?.fall_prevention,
        zipCode: event.target.value,
      },
    });
  };
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      onClose={handleClose}
      disableAutoFocus={true}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className="zip-popup-container"
    >
      <div className="popup-container">
        <div className="title">
          <p>Enter your postal code</p>
          <Clear className="clear-btn" onClick={() => handleClose()} />
        </div>
        <div className="add-message">
          Please enter your postal code to proceed further.
        </div>
        <div className="input-section">
          <Input
            onChange={handleChange}
            placeholder="eg: K0A1T0"
            id="postal-code"
          />
          {inputValidation && (
            <InputLabel className="validation_error">
              {inputValidation}
            </InputLabel>
          )}
          <div className="add-bundle-btn">
            <Button onClick={() => handleZipCodeValid()}>
              {loading ? (
                <CircularProgress className="progress-circle" />
              ) : (
                <span>Verify</span>
              )}
            </Button>
          </div>
        </div>
        <div className="message">
          {apiMessage?.success?.length > 0 && (
            <p className="success">{apiMessage?.success}</p>
          )}
          {apiMessage?.error?.length > 0 && (
            <p className="error">{apiMessage?.error}</p>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ZipCodePopup;
